var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"text-center center"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Page not found")])]),_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("Back")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231ad7c7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = null
// module chunks = 